import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    HubfarmBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.color.brand.darkest,
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
    },
    patternLeft: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 101,
        width: '58%',
    },
    patternRight: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        zIndex: 101,
        maxWidth: '20%',
    },
    tapLogo: {
        width: '100%',
        maxWidth: 400,
        marginBottom: 30,
        zIndex: 105,
    },
});
const HubfarmBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    return (React.createElement("main", { className: classes.HubfarmBackgroundContainer, "data-testid": 'tap-page' },
        React.createElement("img", { src: `${imagesBaseUrl}/hubfarm/assets/images/tap/common/signup_pattern_sx.png`, className: classes.patternLeft }),
        React.createElement("img", { src: `${imagesBaseUrl}/hubfarm/assets/images/tap/common/signup_pattern_dx.png`, className: classes.patternRight }),
        !hideLogo && (React.createElement("img", { alt: 'topcon', src: `${imagesBaseUrl}/hubfarm/assets/images/tap/logo/tap_logo_text.svg`, className: classes.tapLogo })),
        children));
};
export default compose(withBaseProps({ styles }))(HubfarmBackground);
//# sourceMappingURL=index.js.map